import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

/* ================= DATA ================= */
const DEFAULT_NEW_RELEASE_GAMES = [
  {
    id: 1,
    title: "Word Puzzle",
    image: "/assets/gamescard/word-puzzle.png",
    link: "https://thegameio.com/word-puzzle/",
  },
  { id: 2, title: "Different Emoji", image: "/assets/gamescard/different-emoji.png", link: "http://ghanagameium.com/emoji-difference/" },
  { id: 3, title: "Fruit Skill", image: "/assets/gamescard/stick-fruit.png", link: "http://ghanagameium.com/fruit-skill/" },
  { id: 4, title: "Lucky Wheels", image: "/assets/gamescard/lucky-wheel.png", link: "http://ghanagameium.com/luckywheels/" },
  { id: 5, title: "Urban Crosser", image: "/assets/gamescard/urban-crosser.png", link: "http://ghanagameium.com/urban-crosser/" },
  { id: 6, title: "Guess The Quiz", image: "/assets/gamescard/guessquiz.png", link: "http://ghanagameium.com/engaging-emoji/" },
];

const NewRelease = () => {
  const navigate = useNavigate();
 
const handleGameClick = (game) => {
  const isSubscribed = localStorage.getItem("isSubscribed") === "true";

  if (!isSubscribed) {
    Swal.fire({
      title: "🚫 Subscription Required",
      text: "Please subscribe to play games",
      icon: "warning",
      confirmButtonColor: "#ff003c",
      confirmButtonText: "Go to Subscribe",
    }).then((result) => {
      if (result.isConfirmed) {
        navigate("/signin");
      }
    });
    return;
  }

  if (game.link) {
    window.open(game.link, "_self");
  } else {
    console.log("Game link not available");
  }
};

  return (
    <div className="mt-5 relative">

      {/* 🔥 GLOW */}
      <div className="absolute left-[-150px] top-0 w-[300px] h-[300px] rounded-full 
      bg-gradient-to-br from-[#ff003c] to-[#6a00ff] opacity-10 blur-[120px]" />

      <div className="w-full py-10 px-4 relative z-10">
        <div className="max-w-6xl mx-auto">

          {/* ================= HEADER ================= */}
          <div className="flex flex-wrap justify-between items-center mb-8 gap-4">

            <p className="text-white text-[22px] sm:text-[25px] md:text-3xl font-bold uppercase">
              <span className="text-[#ff003c]">New</span> Release
            </p>

            <div className="flex items-center gap-3">

              {/* VIEW ALL */}
              <button
                onClick={() => navigate("/games")}
                className="px-5 py-2 rounded-lg text-white font-semibold 
                bg-gradient-to-r from-[#ff003c] to-[#6a00ff]
                hover:scale-105 transition-all duration-300 shadow-lg"
              >
                View All
              </button>

              {/* ARROWS */}
              <button className="swiper-button-prev-release 
              bg-[#1f1f35] hover:bg-gradient-to-r hover:from-[#ff003c] hover:to-[#6a00ff]
              w-10 h-10 rounded-lg flex items-center justify-center transition">
                <IoIosArrowBack size={18} color="#fff" />
              </button>

              <button className="swiper-button-next-release 
              bg-[#1f1f35] hover:bg-gradient-to-r hover:from-[#ff003c] hover:to-[#6a00ff]
              w-10 h-10 rounded-lg flex items-center justify-center transition">
                <IoIosArrowForward size={18} color="#fff" />
              </button>

            </div>
          </div>

          {/* ================= SLIDER ================= */}
          <Swiper
            modules={[Navigation, Autoplay]}
            navigation={{
              prevEl: ".swiper-button-prev-release",
              nextEl: ".swiper-button-next-release",
            }}
            autoplay={{ delay: 3500, disableOnInteraction: false }}
            loop
            spaceBetween={20}
            breakpoints={{
              0: { slidesPerView: 2 },
              640: { slidesPerView: 3 },
              1024: { slidesPerView: 4 },
              1280: { slidesPerView: 5 },
            }}
          >
            {DEFAULT_NEW_RELEASE_GAMES.map((game) => (
              <SwiperSlide key={game.id}>
                <div
                  onClick={() => handleGameClick(game)}
                  className="group cursor-pointer flex flex-col"
                >

                  {/* CARD */}
                  <div className="rounded-xl bg-[#141422] 
                  border border-[#ffffff10]
                  hover:border-[#ff003c]
                  transition-all duration-300
                  hover:shadow-[0_0_20px_rgba(255,0,60,0.4)]
                  overflow-hidden">

                     {/* IMAGE FIX 🔥 */}
                    <div className="w-full h-[160px] sm:h-[200px] md:h-[220px] overflow-hidden">
                      <img
                        src={game.image}
                        alt={game.title}
                        className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                      />
                    </div>

                  </div>

                  {/* TITLE */}
                  <h3 className="text-white text-sm sm:text-base font-semibold mt-4 text-center 
                  group-hover:text-[#ff003c] transition">
                    {game.title}
                  </h3>

                </div>
              </SwiperSlide>
            ))}
          </Swiper>

        </div>
      </div>
    </div>
  );
};

export default NewRelease;